import { render, staticRenderFns } from "./SellerComment.vue?vue&type=template&id=101dc5c4&"
import script from "./SellerComment.vue?vue&type=script&lang=js&"
export * from "./SellerComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports